import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import BrowserOnly from 'components/consumer/BrowserOnly';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPNameSection from '../PDPNameSection';
import PDPMobileStudioPhotoGallery from '../PDPMobileStudioPhotoGallery';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPAvailableInSizes from '../PDPAvailableInSizes';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPMobileConfigurationPhotoGallery from '../PDPMobileConfigurationPhotoGallery';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPCompleteOrder from '../PDPCompleteOrder';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPSellingAttributes from '../PDPSellingAttributes';
import PDPProductDescription from '../PDPProductDescription';
import PDPDimensionsAndDetails from '../PDPDimensionsAndDetails';
import BVReviewsOnShowHost from '../BazaarVoice/BVReviewsOnShowHost';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPDetailsAndProductCareLink from '../PDPDetailsAndProductCareLink';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPMobileGalleryRevamp from '../PDPMobileGalleryRevamp';
import useIsGalleryRevampVariant from '../useIsGalleryRevampVariant';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const ModularAddProductsMarxent = loadable(() => import('components/consumer/modular-configurator/ModularAddProducts/marxent'));
const PDPMobileGalleryByVariant = t0 => {
  const $ = _c(6);
  const {
    slug,
    pdpIsModularBYOProduct,
    isEditOrder,
    productHeroImage,
    productCylindoHeroImage
  } = t0;
  const showGalleryRevamp = useIsGalleryRevampVariant(!pdpIsModularBYOProduct && !isEditOrder);
  let t1;
  if ($[0] !== pdpIsModularBYOProduct || $[1] !== productCylindoHeroImage || $[2] !== productHeroImage || $[3] !== showGalleryRevamp || $[4] !== slug) {
    t1 = showGalleryRevamp ? <PDPMobileGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} /> : <PDPMobileStudioPhotoGallery pdpIsModularBYOProduct={pdpIsModularBYOProduct} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} />;
    $[0] = pdpIsModularBYOProduct;
    $[1] = productCylindoHeroImage;
    $[2] = productHeroImage;
    $[3] = showGalleryRevamp;
    $[4] = slug;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
PDPMobileGalleryByVariant.propTypes = {
  slug: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
const hasMobileConfigurationOptions = ({
  isEFGInternal,
  optionData
}) => !isEFGInternal || isEFGInternal && !optionData?.hasSingleOptionValue;
const PDPMobileConfigurationGallery = t0 => {
  const $ = _c(8);
  const {
    show,
    slug,
    galleryRef,
    isEditOrder,
    pdpIsModularBYOProduct,
    hideMarxent,
    unavailableFabric
  } = t0;
  let t1;
  if ($[0] !== galleryRef || $[1] !== hideMarxent || $[2] !== isEditOrder || $[3] !== pdpIsModularBYOProduct || $[4] !== show || $[5] !== slug || $[6] !== unavailableFabric) {
    t1 = show ? <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper" ref={galleryRef}><PDPMobileConfigurationPhotoGallery slug={slug} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} marxentPostHogFlag="test" hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /></div> : <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper-filler" />;
    $[0] = galleryRef;
    $[1] = hideMarxent;
    $[2] = isEditOrder;
    $[3] = pdpIsModularBYOProduct;
    $[4] = show;
    $[5] = slug;
    $[6] = unavailableFabric;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
PDPMobileConfigurationGallery.propTypes = {
  show: PropTypes.bool,
  slug: PropTypes.string,
  galleryRef: PropTypes.object,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool
};
const PDPMobileConfigurationGalleryByVariant = t0 => {
  const $ = _c(12);
  const {
    slug,
    galleryRef,
    isEFGInternal,
    optionData,
    isEditOrder,
    pdpIsModularBYOProduct,
    hideMarxent,
    unavailableFabric
  } = t0;
  const showGalleryRevamp = useIsGalleryRevampVariant(!pdpIsModularBYOProduct && !isEditOrder);
  let t1;
  if ($[0] !== isEFGInternal || $[1] !== optionData || $[2] !== showGalleryRevamp) {
    t1 = !showGalleryRevamp && hasMobileConfigurationOptions({
      isEFGInternal,
      optionData
    });
    $[0] = isEFGInternal;
    $[1] = optionData;
    $[2] = showGalleryRevamp;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const showConfigurationGallery = t1;
  let t2;
  if ($[4] !== galleryRef || $[5] !== hideMarxent || $[6] !== isEditOrder || $[7] !== pdpIsModularBYOProduct || $[8] !== showConfigurationGallery || $[9] !== slug || $[10] !== unavailableFabric) {
    t2 = <PDPMobileConfigurationGallery show={showConfigurationGallery} slug={slug} galleryRef={galleryRef} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} />;
    $[4] = galleryRef;
    $[5] = hideMarxent;
    $[6] = isEditOrder;
    $[7] = pdpIsModularBYOProduct;
    $[8] = showConfigurationGallery;
    $[9] = slug;
    $[10] = unavailableFabric;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
PDPMobileConfigurationGalleryByVariant.propTypes = {
  slug: PropTypes.string,
  galleryRef: PropTypes.object,
  isEFGInternal: PropTypes.bool,
  optionData: PropTypes.object,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool
};

/**
 * Mobile layout: gallery shell sits above the stock-gated options rail.
 * Outer full-page Suspense was removed — hero/context boundaries live in
 * PDPHeroShell / PDPContextRegion; sections keep their own.
 */
const PDPMobile = t0 => {
  const $ = _c(75);
  const {
    slug,
    isOutOfStock: t1,
    showOutOfStockNotification: t2,
    pdpIsModularBYOProduct: t3,
    isEditOrder: t4,
    showDiscontinuedNotification: t5,
    discontinuedCategoryMsg: t6,
    productHeroImage: t7,
    productCylindoHeroImage: t8
  } = t0;
  const isOutOfStock = t1 === undefined ? false : t1;
  let t9;
  if ($[0] !== t2) {
    t9 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const showOutOfStockNotification = t9;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const isEditOrder = t4 === undefined ? false : t4;
  const showDiscontinuedNotification = t5 === undefined ? false : t5;
  const discontinuedCategoryMsg = t6 === undefined ? null : t6;
  const productHeroImage = t7 === undefined ? null : t7;
  const productCylindoHeroImage = t8 === undefined ? null : t8;
  const {
    isEFGInternal: t10
  } = useProductEFGInternalStatus();
  const isEFGInternal = t10 === undefined ? false : t10;
  const {
    data: optionData
  } = usePDPOptions();
  const isBrowser = useIsBrowser();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  const [marxentSelectedFabric, setMarxentSelectedFabric] = useState(null);
  const [hideMarxent, setHideMarxent] = useState(true);
  const [unavailableFabric, setUnavailableFabric] = useState(false);
  const galleryRef = useRef(null);
  let t11;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      if (galleryRef.current) {
        galleryRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    };
    $[2] = t11;
  } else {
    t11 = $[2];
  }
  const scrollToGallery = t11;
  let t12;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-4"><PDPBreadCrumbs /></div>;
    $[3] = t12;
  } else {
    t12 = $[3];
  }
  let t13;
  if ($[4] !== isEditOrder) {
    t13 = <PDPNameSection isEditOrder={isEditOrder} />;
    $[4] = isEditOrder;
    $[5] = t13;
  } else {
    t13 = $[5];
  }
  let t14;
  if ($[6] !== isBrowser || $[7] !== isEditOrder) {
    t14 = !isEditOrder && isBrowser ? <PDPAvailableInSizes /> : <div className="PDP__PDPAvailableInSizes-filler" />;
    $[6] = isBrowser;
    $[7] = isEditOrder;
    $[8] = t14;
  } else {
    t14 = $[8];
  }
  let t15;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <PDPOnDisplayInShowroom />;
    $[9] = t15;
  } else {
    t15 = $[9];
  }
  let t16;
  if ($[10] !== t14) {
    t16 = <FixedWidthContainer>{t14}{t15}</FixedWidthContainer>;
    $[10] = t14;
    $[11] = t16;
  } else {
    t16 = $[11];
  }
  let t17;
  if ($[12] !== isEditOrder || $[13] !== pdpIsModularBYOProduct || $[14] !== productCylindoHeroImage || $[15] !== productHeroImage || $[16] !== slug) {
    t17 = <div><PDPMobileGalleryByVariant slug={slug} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isEditOrder={isEditOrder} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} /></div>;
    $[12] = isEditOrder;
    $[13] = pdpIsModularBYOProduct;
    $[14] = productCylindoHeroImage;
    $[15] = productHeroImage;
    $[16] = slug;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== isEditOrder) {
    t18 = <FixedWidthContainer><PDPShopTabsBar isEditOrder={isEditOrder} /></FixedWidthContainer>;
    $[18] = isEditOrder;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] !== hideMarxent || $[21] !== isEFGInternal || $[22] !== isEditOrder || $[23] !== optionData || $[24] !== pdpIsModularBYOProduct || $[25] !== slug || $[26] !== unavailableFabric) {
    t19 = <ReRenderOnMount><PDPMobileConfigurationGalleryByVariant slug={slug} galleryRef={galleryRef} isEFGInternal={isEFGInternal} optionData={optionData} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /></ReRenderOnMount>;
    $[20] = hideMarxent;
    $[21] = isEFGInternal;
    $[22] = isEditOrder;
    $[23] = optionData;
    $[24] = pdpIsModularBYOProduct;
    $[25] = slug;
    $[26] = unavailableFabric;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== discontinuedCategoryMsg || $[29] !== showDiscontinuedNotification) {
    t20 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPMobile__PDPAlertBar-filler" />;
    $[28] = discontinuedCategoryMsg;
    $[29] = showDiscontinuedNotification;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== isEditOrder || $[32] !== isOutOfStock || $[33] !== marxentSelectedFabric || $[34] !== pdpIsModularBYOProduct || $[35] !== showDiscontinuedNotification || $[36] !== slug || $[37] !== unavailableFabric) {
    t21 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPMobile__PDPChooseYourOptions-wrapper">{pdpIsModularBYOProduct && <BrowserOnly><div className="border-t border-gray-light7"><SuspenseWithLoader><ModularAddProductsMarxent marxentSelectedFabric={marxentSelectedFabric} unavailableFabric={unavailableFabric} setHideMarxent={setHideMarxent} setUnavailableFabric={setUnavailableFabric} scrollToGallery={scrollToGallery} key={slug} /></SuspenseWithLoader></div></BrowserOnly>}<PDPChooseYourOptions isEditOrder={isEditOrder} setMarxentSelectedFabric={setMarxentSelectedFabric} />{!isEditOrder && <PDPUpSellProduct />}{!isEditOrder && <PDPProtectionPlanSelector />}</div> : <div className="PDPMobile__PDPChooseYourOptions-wrapper-filler" />;
    $[31] = isEditOrder;
    $[32] = isOutOfStock;
    $[33] = marxentSelectedFabric;
    $[34] = pdpIsModularBYOProduct;
    $[35] = showDiscontinuedNotification;
    $[36] = slug;
    $[37] = unavailableFabric;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== isOutOfStock || $[40] !== showDiscontinuedNotification || $[41] !== showOutOfStockNotification) {
    t22 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPMobile__PDPAlertSection-filler" />;
    $[39] = isOutOfStock;
    $[40] = showDiscontinuedNotification;
    $[41] = showOutOfStockNotification;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== isEditOrder || $[44] !== isOutOfStock) {
    t23 = isEditOrder ? <PDPCompleteOrder /> : <PDPAddToBagSection isOutOfStock={isOutOfStock} />;
    $[43] = isEditOrder;
    $[44] = isOutOfStock;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t20 || $[47] !== t21 || $[48] !== t22 || $[49] !== t23) {
    t24 = <div>{t20}{t21}{t22}{t23}</div>;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  let t26;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <PDPKeySellingPoints />;
    t26 = <PDPSellingAttributes />;
    $[51] = t25;
    $[52] = t26;
  } else {
    t25 = $[51];
    t26 = $[52];
  }
  let t27;
  if ($[53] !== isEditOrder) {
    t27 = !isEditOrder && <PDPProductDescription />;
    $[53] = isEditOrder;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== pdpIsModularBYOProduct) {
    t28 = !pdpIsModularBYOProduct ? <PDPDimensionsAndDetails /> : <PDPDetailsAndProductCareLink />;
    $[55] = pdpIsModularBYOProduct;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== isEditOrder || $[58] !== slug) {
    t29 = !isEditOrder ? <PDPCustomerPhotos slug={slug} /> : <BVReviewsOnShowHost />;
    $[57] = isEditOrder;
    $[58] = slug;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== displayPressComp) {
    t30 = !displayPressComp ? <SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} /></SuspenseWithLoader> : <div className="PDPMobile__PDPPress-filler" />;
    $[60] = displayPressComp;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] !== t24 || $[63] !== t27 || $[64] !== t28 || $[65] !== t29 || $[66] !== t30) {
    t31 = <FixedWidthContainer>{t24}{t25}{t26}{t27}{t28}{t29}{t30}</FixedWidthContainer>;
    $[62] = t24;
    $[63] = t27;
    $[64] = t28;
    $[65] = t29;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== t13 || $[69] !== t16 || $[70] !== t17 || $[71] !== t18 || $[72] !== t19 || $[73] !== t31) {
    t32 = <div className="PDPMobile lg:hidden" data-xc="PDPMobile">{t12}{t13}{t16}{t17}{t18}{t19}{t31}</div>;
    $[68] = t13;
    $[69] = t16;
    $[70] = t17;
    $[71] = t18;
    $[72] = t19;
    $[73] = t31;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  return t32;
};
PDPMobile.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPMobile;